import { createFilePreview } from '../utils/filePreview';
import { handleApiCalls } from './axiosInstance';

const AxleAPI = Object.freeze({
  /**
   * Start Axle ignition
   * @returns {Promise<Object>} - The response from the API
   */
  startIgnition: async () => {
    const url = `${process.env.REACT_APP_HOST_API}axle/ignition`;
    const result = await handleApiCalls('post', url);
    return result.data;
  },

  exchangeToken: async ({ authCode, ignitionToken, ignitionResult }) => {
    const url = `${process.env.REACT_APP_HOST_API}axle/token/exchange`;
    const result = await handleApiCalls('post', url, {
      authCode,
      ignitionToken,
      result: ignitionResult,
    });

    return result.data;
  },

  /**
   * Fetches a preview of the insurance document for a specific policy.
   * @param {string} policyId - The ID of the policy for which the document preview is requested.
   * @returns {Promise<{url: string, type: string, width?: number, height?: number}>} - The document preview URL and metadata.
   */
  fetchAxleInsuranceDocumentPreview: async policyId => {
    const url = `${process.env.REACT_APP_HOST_API}axle-policies/${policyId}/report`;
    const response = await handleApiCalls('get', url, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
      },
    });

    return createFilePreview(response.data, response.headers?.['content-type']);
  },

  /**
   * Updates an Axle policy with new information.
   * @param {string} policyId - The ID of the policy to update.
   * @param {Object} data - The modified policy data.
   * @returns {Promise<Object>} - The updated policy data.
   */
  updateAxlePolicy: async (policyId, data) => {
    const url = `${process.env.REACT_APP_HOST_API}axle-policies/${policyId}`;
    const response = await handleApiCalls('put', url, data);
    return response.data;
  },
});

export default AxleAPI;
